import 'react-native-gesture-handler'; // must at top, If you are building for Android or iOS, do not skip this step, or your app may crash in production even if it works fine in development. This is not applicable to other platforms.
import * as React from 'react';
import AppRoot from "./src/AppRoot";

export default function App() {
    return (
        <AppRoot/>
    );
}